<script>
import LabReportForm from '../components/labReport/LabReportForm'
import { createLabReport } from '../services/labReportService'
import { LAB_REPORTS_COUNT } from '../graphql/queries/LabReportQueries'
import myPlanData from '../mixins/myPlanData'
import { ContentLoader } from 'vue-content-loader'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'AddLabReportView',
  components: {
    LabReportForm,
    ContentLoader
  },
  mixins: [myPlanData],
  data() {
    return {
      loading: false,
      report: {
        date: new Date(),
        lab: '',
        results: []
      },
      isMobile: isMobile
    }
  },
  apollo: {
    labReportsCount: LAB_REPORTS_COUNT
  },
  mounted() {
    const biomarker = this.$route.params.biomarker
    if (biomarker) {
      this.report.results.push(biomarker)
    }
  },
  computed: {
    ableToAddReport() {
      return this.isSubscribed || this.labReportsCount === 0
    }
  },
  methods: {
    successMessage() {
      this.$snackbar.open({
        message: 'Lab report saved',
        type: 'is-secondary',
        position: 'is-bottom-left'
      })
    },
    async saveReport(labReport) {
      try {
        this.loading = true
        const reportData = await createLabReport(labReport)
        if (reportData) {
          this.$amplitude.logEvent('Report Created', {
            id: reportData._id,
            lab_name: reportData.lab,
            date: reportData.date
          })
          this.successMessage()
          this.$router.push('/dashboard')
          this.loading = false
        }
      } catch (error) {
        // ToDo: add validation
        console.log(error)
      }
    }
  }
}
</script>

<template>
  <div class="container section add-lab-report-view">
    <ContentLoader
      v-if="$apollo.loading"
      :height="150"
      :width="isMobile ? 200 : 400"
      :speed="3"
    >
      <rect x="0" y="0" rx="3" ry="3" width="155" height="12" />
      <rect x="0" y="20" rx="3" ry="3" width="350" height="4" />
      <rect x="0" y="30" rx="3" ry="3" width="380" height="4" />
      <rect x="0" y="40" rx="3" ry="3" width="201" height="4" />
    </ContentLoader>
    <div v-if="!$apollo.loading" class="container">
      <section v-if="ableToAddReport">
        <h2 class="title is-3">Add lab report</h2>
        <hr class="spacer" />
        <LabReportForm :lab-report="report" @submit="saveReport" />
      </section>

      <section v-else>
        <b-message aria-close-label="Close message"
          >Free users can only add one report. Subscribe to track results over
          time.</b-message
        >
      </section>
    </div>
  </div>
</template>

<style scoped lang="sass">
.save-button
  margin-top: 5%
</style>
